<template>
  <draggable tag="ul" :list="fieldTypes" class="list-group dragArea"
             :sort="false"
             :group="{
               name: 'components',
               pull: 'clone',
               put: false
             }"
             @start="$emit('drag-started')"
             :clone="onClone">
    <li v-for="(component, index) in fieldTypes" class="list-group-item col-md-12"
        :key="'item-list-key' + index">
      <i :class="icons[component.type]"></i> {{ component.label }}
    </li>
  </draggable>
</template>

<script>
import { computed } from 'vue';
import draggable from 'vuedraggable';

import formBuilderIcons from '@/utils/formBuilder/icons';

export default {
  components: {
    draggable,
  },
  emits: ['shared-field-added', 'drag-started'],
  props: {
    includeDestinationAccountField: {
      type: Boolean,
      default: false,
    },
    includeProgramsCheckboxGroupField: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit}) {
    const DEFAULT_FIELD_TYPES = [
      {
        label: "Header",
        type: "header",
        grid: 12,
        size: "h1",
      },
      {
        label: "Subheader",
        type: "text-entry",
        grid: 12
      },
      {
        label: "Divider",
        type: "divider",
        grid: 12
      },
      {
        label: "Row",
        type: "row",
        grid: 12
      },
      {
        label: "Checkbox",
        type: "checkbox",
        grid: 12
      },
      {
        label: "Time",
        type: "time",
        grid: 4
      },
      {
        label: "Checkbox Group",
        type: "checkbox-group",
        grid: 12,
        values: []
      },
      {
        label: "Radio Group",
        type: "radio-group",
        grid: 12,
        values: []
      },
      {
        label: "Accordion",
        type: "accordion",
        grid: 12,
        values: []
      },
      {
        label: "Currency",
        type: "currency",
        grid: 4,
        maxSize: ""
      },
      {
        label: "Short Text Entry",
        type: "text",
        grid: 12,
        maxSize: "",
        minSize: ""
      },
      {
        label: "Long Text Entry",
        type: "textarea",
        grid: 12,
        maxSize: ""
      },
      {
        label: "Phone",
        type: "phone",
        grid: 4,
      },
      {
        label: "SSN",
        type: "ssn",
        grid: 4,
      },
      {
        label: 'Dropdown',
        type: 'select',
        multiple: false,
        grid: 12,
        values: []
      },
      {
        label: "File Upload",
        type: "file",
        grid: 12,
        content: [],
        multiple: false
      },
      {
        label: "Image Upload",
        type: "image-upload",
        grid: 12,
        button: "Upload image"
      },
      {
        label: "System ID",
        type: "systemid",
        grid: 4,
      },
      {
        label: "Date Field",
        type: "date",
        grid: 4
      },
      {
        label: "Number",
        type: "number",
        grid: 4
      },
      {
        label: "Scale Rating",
        type: "rating",
        grid: 12,
        min: 1,
        max: 5,
        minText: "Type worst text",
        maxText: "Type best text",
        values: []
      },
      {
        label: "Address",
        type: "address",
        grid: 12,
      },
      {
        label: "Electronic Signature",
        type: "signature",
        grid: 12
      },
      {
        label: "Case Manager",
        type: "select2",
        grid: 12,
      },
      {
        label: "Case Manager (Secondary)",
        type: "select_case_manager_secondary",
        grid: 12,
      },
      {
        label: "Shared Field",
        type: "shared-field",
        grid: 12,
      },
      {
        label: "Shared Form Summary",
        type: "shared-form-preview",
        grid: 12,
      }
    ]

    const fieldTypes = computed(() => {
      const types = [...DEFAULT_FIELD_TYPES]

      if (props.includeProgramsCheckboxGroupField) {
        types.push(
          {
            label: "Programs",
            type: "programs-checkbox-group",
            grid: 12,
          }
        )
      }

      if (props.includeDestinationAccountField) {
        types.push(
          {
            label: "CaseMGR Account Destination",
            type: "destination-account",
            grid: 12,
          }
        )
      }
      return types
    })

    const onClone = (el) => {
      let input = JSON.parse(JSON.stringify(el));
      input.name = input.type + '-' + Date.now();
      input.fixed = false;
      input.required = false;
      input.disabled = false;
      input.hide = false;

      if (!['row', 'divider', 'accordion'].includes(input.type)) {
        input.description = input.label;
      }

      if (input.type === 'shared-field') {
        emit('shared-field-added', input.name)
      }

      return input
    }

    return {
      fieldTypes,
      icons: formBuilderIcons,
      onClone,
    }
  }
}
</script>

<style scoped lang="scss">
.sortable-ghost {
  opacity: 0;
}
.list-group-item {
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// VueFormBuilderFieldList.vue?03e4df32